// Observability bootstrap step. Initialises the OpenTelemetry browser SDK so
// every user-triggered fetch/XHR carries the W3C `traceparent` header and
// backend services can join the same trace.
//
// Run AFTER initSentry (Sentry browser tracing must be in place first) and
// BEFORE the router/page-tracking step so the first navigation span is
// captured. Both stacks coexist: Sentry for error/crash reporting, OTel for
// distributed tracing.
//
// When VITE_OTEL_OTLP_ENDPOINT is unset, initOtel() is a no-op and the
// app runs with the no-op tracer — safe for dev/CI.

import { initOtel } from '@core/observability/otel'

export const initObservability = (): void => {
  initOtel()
}
